if (!window.oly) window.oly = {};

window.oly.extension_utils = {
  trip_advisor: {
    getCompanyId({ url = "", companies = [] } = {}) {
      const locationId  = new URLSearchParams(new URL(url).searchParams).get("locationId");
      const findCompany = companies.find(c => c.trip_advisor_id == locationId);
      return findCompany;
    }
  }
}

export default window.oly.extension_utils;
